module.exports = __webpack_public_path__ + "img/katarina_outside_3.1b0cd2e4.jpg";